module.exports = __webpack_public_path__ + "static/media/hotspots.ebd81d44.jpg";